import { useAtom } from '@reatom/npm-react'
import * as DateF from 'date-fns'
import styled from 'styled-components'

import { dateBySecondAtom } from '@root/shared/lib'
import { useDateFnsLocale, useTranslation } from '@root/shared/localization'

type RankCellProps = {
  lastActiveAt: Date
}

function wasInPreviousHour(date: Date, baseDate: Date): boolean {
  const oneHourAgo = DateF.subHours(baseDate, 1)
  return DateF.isAfter(date, oneHourAgo)
}

export const HolderTableLastActiveCell = (props: RankCellProps) => {
  const locale = useDateFnsLocale()
  const { t } = useTranslation()
  const [now] = useAtom(dateBySecondAtom)
  const time = DateF.formatDistance(props.lastActiveAt, now, {
    locale,
    includeSeconds: true,
  })
  const timeAgo = time ? t('common.ago', { time }) : t('common.n_a')

  return (
    <Root>
      <Text
        $color={
          wasInPreviousHour(props.lastActiveAt, now)
            ? 'var(--up-9)'
            : 'var(--text-11)'
        }
      >
        {timeAgo}
      </Text>
    </Root>
  )
}

const Root = styled.div`
  overflow: hidden;
`
const Text = styled.div<{ $color: string }>`
  color: ${(props) => props.$color};

  overflow: hidden;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
`
